import React from 'react';

import { FormattedMessage } from 'react-intl';

import Button from '@atlaskit/button/default/button';
import Heading from '@atlaskit/heading/heading';
import MagicWandIcon from '@atlaskit/icon/core/magic-wand';
import Image from '@atlaskit/image';
import { Flex } from '@atlaskit/primitives/compiled/flex';
// eslint-disable-next-line @atlaskit/platform/no-barrel-entry-imports
import { noDynamicCards } from '@atlassian/company-hub-common/assets';

import { messages } from './messages';

type EmptyStateContainerProps = { startCreateFilters: () => void };

export const EmptyStateContainer = ({
	startCreateFilters,
}: EmptyStateContainerProps): React.JSX.Element => {
	return (
		<Flex
			direction="column"
			justifyContent="center"
			alignItems="center"
			gap="space.200"
			testId="empty-state-container"
		>
			<Image src={noDynamicCards} alt="" testId="no-dynamic-cards-image" />

			<Heading size="medium">
				<FormattedMessage {...messages.noDynamicCards} />
			</Heading>

			<Button shouldFitContainer appearance="primary" onClick={startCreateFilters}>
				<Flex gap="space.100" justifyContent="center">
					<MagicWandIcon label="" />
					<FormattedMessage {...messages.buildDynamicCards} />
				</Flex>
			</Button>
		</Flex>
	);
};
